import { TaskItem } from '@domains/documents-review/interfaces/interfaces';
import { LeadDetail } from '../interfaces/interfaces';

export const leadDetailDataCO = (
  leadDetail: LeadDetail,
  taskData: TaskItem | null
) => ({
  agent: taskData?.agent || '',
  address: leadDetail.location?.address || '',
  building_complex: leadDetail.location?.house_complex || '',
  country: 'CO',
  elevator: Number(leadDetail.property.elevator) ?? 0,
  price_type: leadDetail.pricing?.last_deal_business_status || '',
  property_deal_id: Number(leadDetail.id) ?? 0,
  property_type_id: Number(leadDetail.property.property_type_id) ?? 0,
  latitude: leadDetail.location?.coordinates?.[0] ?? 0,
  longitude: leadDetail.location?.coordinates?.[1] ?? 0,
  land_area: Number(leadDetail.property?.land) ?? 0,
  room_num: Number(leadDetail.property.rooms) ?? 0,
  validations: true,
});

export const leadDetailDataMX = (
  leadDetail: LeadDetail,
  taskData: TaskItem | null
) => ({
  agent: taskData?.agent || '',
  address: leadDetail.location?.address || '',
  country: 'MX',
  exterior_number: leadDetail.location?.exterior_number || '',
  mex_state_id: leadDetail.location?.state_id || '',
  price_type: leadDetail.pricing?.last_deal_business_status || '',
  property_deal_id: Number(leadDetail.id) ?? 0,
  latitude: leadDetail.location?.coordinates?.[0] ?? 0,
  longitude: leadDetail.location?.coordinates?.[1] ?? 0,
  validations: true,
});
